// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AiChatController from "./ai_chat_controller"
application.register("ai-chat", AiChatController)

import AiChatLauncherController from "./ai_chat_launcher_controller"
application.register("ai-chat-launcher", AiChatLauncherController)

import AiTranslateController from "./ai_translate_controller"
application.register("ai-translate", AiTranslateController)

import AutoAdvanceController from "./auto_advance_controller"
application.register("auto-advance", AutoAdvanceController)

import AutoHeightController from "./auto_height_controller"
application.register("auto-height", AutoHeightController)

import AutoResizeController from "./auto_resize_controller"
application.register("auto-resize", AutoResizeController)

import AutoSaveController from "./auto_save_controller"
application.register("auto-save", AutoSaveController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import BottomSheetController from "./bottom_sheet_controller"
application.register("bottom-sheet", BottomSheetController)

import BrandMonthsChartController from "./brand_months_chart_controller"
application.register("brand-months-chart", BrandMonthsChartController)

import Bridge__FacebookSignInController from "./bridge/facebook_sign_in_controller"
application.register("bridge--facebook-sign-in", Bridge__FacebookSignInController)

import Bridge__FormController from "./bridge/form_controller"
application.register("bridge--form", Bridge__FormController)

import Bridge__GoogleSignInController from "./bridge/google_sign_in_controller"
application.register("bridge--google-sign-in", Bridge__GoogleSignInController)

import Bridge__LocaleController from "./bridge/locale_controller"
application.register("bridge--locale", Bridge__LocaleController)

import Bridge__NavBarController from "./bridge/nav_bar_controller"
application.register("bridge--nav-bar", Bridge__NavBarController)

import Bridge__OverflowMenuController from "./bridge/overflow_menu_controller"
application.register("bridge--overflow-menu", Bridge__OverflowMenuController)

import Bridge__ReviewController from "./bridge/review_controller"
application.register("bridge--review", Bridge__ReviewController)

import Bridge__SignOutController from "./bridge/sign_out_controller"
application.register("bridge--sign-out", Bridge__SignOutController)

import Bridge__ThemeController from "./bridge/theme_controller"
application.register("bridge--theme", Bridge__ThemeController)

import CheckboxController from "./checkbox_controller"
application.register("checkbox", CheckboxController)

import CheckoutFeedbackController from "./checkout_feedback_controller"
application.register("checkout-feedback", CheckoutFeedbackController)

import CheckoutReturnController from "./checkout_return_controller"
application.register("checkout-return", CheckoutReturnController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CollapseController from "./collapse_controller"
application.register("collapse", CollapseController)

import CommentController from "./comment_controller"
application.register("comment", CommentController)

import ConsentBannerController from "./consent_banner_controller"
application.register("consent-banner", ConsentBannerController)

import CountryMapController from "./country_map_controller"
application.register("country-map", CountryMapController)

import CountrySelectController from "./country_select_controller"
application.register("country-select", CountrySelectController)

import CsrfRefreshController from "./csrf_refresh_controller"
application.register("csrf-refresh", CsrfRefreshController)

import DailyActivityChartController from "./daily_activity_chart_controller"
application.register("daily-activity-chart", DailyActivityChartController)

import DemoQuestionController from "./demo_question_controller"
application.register("demo-question", DemoQuestionController)

import DodoBillingController from "./dodo_billing_controller"
application.register("dodo-billing", DodoBillingController)

import DodoCheckoutController from "./dodo_checkout_controller"
application.register("dodo-checkout", DodoCheckoutController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import DynamicSelectController from "./dynamic_select_controller"
application.register("dynamic-select", DynamicSelectController)

import ExplanationPopoverController from "./explanation_popover_controller"
application.register("explanation-popover", ExplanationPopoverController)

import FeedbackController from "./feedback_controller"
application.register("feedback", FeedbackController)

import FinanceChartController from "./finance_chart_controller"
application.register("finance-chart", FinanceChartController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import GuestExamChallengeController from "./guest_exam_challenge_controller"
application.register("guest-exam-challenge", GuestExamChallengeController)

import GuestExamSettingsController from "./guest_exam_settings_controller"
application.register("guest-exam-settings", GuestExamSettingsController)

import HoverActionsController from "./hover_actions_controller"
application.register("hover-actions", HoverActionsController)

import ImageLoaderController from "./image_loader_controller"
application.register("image-loader", ImageLoaderController)

import ImageZoomController from "./image_zoom_controller"
application.register("image-zoom", ImageZoomController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import LimitTimerController from "./limit_timer_controller"
application.register("limit-timer", LimitTimerController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MonthlyStatsChartController from "./monthly_stats_chart_controller"
application.register("monthly-stats-chart", MonthlyStatsChartController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import OnboardingController from "./onboarding_controller"
application.register("onboarding", OnboardingController)

import OtpInputController from "./otp_input_controller"
application.register("otp-input", OtpInputController)

import PaywallFeedbackController from "./paywall_feedback_controller"
application.register("paywall-feedback", PaywallFeedbackController)

import PaywallModalController from "./paywall_modal_controller"
application.register("paywall-modal", PaywallModalController)

import PeriodSelectorController from "./period_selector_controller"
application.register("period-selector", PeriodSelectorController)

import PushNotificationsController from "./push_notifications_controller"
application.register("push-notifications", PushNotificationsController)

import QuestionController from "./question_controller"
application.register("question", QuestionController)

import QuestionKeysController from "./question_keys_controller"
application.register("question-keys", QuestionKeysController)

import ReportMistakeController from "./report_mistake_controller"
application.register("report-mistake", ReportMistakeController)

import SaveVerifyNextController from "./save_verify_next_controller"
application.register("save-verify-next", SaveVerifyNextController)

import ScrollController from "./scroll_controller"
application.register("scroll", ScrollController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import StatusFilterController from "./status_filter_controller"
application.register("status-filter", StatusFilterController)

import SwipeNavController from "./swipe_nav_controller"
application.register("swipe-nav", SwipeNavController)

import TestLanguageFilterController from "./test_language_filter_controller"
application.register("test-language-filter", TestLanguageFilterController)

import TextLengthController from "./text_length_controller"
application.register("text-length", TextLengthController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import ThemeToggleController from "./theme_toggle_controller"
application.register("theme-toggle", ThemeToggleController)

import TimerController from "./timer_controller"
application.register("timer", TimerController)

import TurboModalController from "./turbo_modal_controller"
application.register("turbo-modal", TurboModalController)

import TurnstileController from "./turnstile_controller"
application.register("turnstile", TurnstileController)

import UploadController from "./upload_controller"
application.register("upload", UploadController)

import WikiSearchController from "./wiki_search_controller"
application.register("wiki-search", WikiSearchController)

import WikiSidebarController from "./wiki_sidebar_controller"
application.register("wiki-sidebar", WikiSidebarController)

import WikiSortableController from "./wiki_sortable_controller"
application.register("wiki-sortable", WikiSortableController)

import WikiTocController from "./wiki_toc_controller"
application.register("wiki-toc", WikiTocController)

import WikiTreeController from "./wiki_tree_controller"
application.register("wiki-tree", WikiTreeController)
